import { render } from "./BorderSideDetail.vue?vue&type=template&id=43207ed5&scoped=true&ts=true"
import script from "./BorderSideDetail.vue?vue&type=script&lang=ts"
export * from "./BorderSideDetail.vue?vue&type=script&lang=ts"

import "./BorderSideDetail.vue?vue&type=style&index=0&id=43207ed5&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43207ed5"]])

export default __exports__